module.exports = __webpack_public_path__ + "img/Slide12.77454abb.png";